import { calculateIsoscelesTriangleSide } from './calculateIsoscelesTriangleSide';

import { CornerInfo } from '~/core/models';

export const calculateStartPointAdjustment = (
  startPt: CornerInfo,
  cos: number,
  sin: number,
  batAdjustStart: number,
  initialSpX: number,
  initialSpY: number
): { spX: number; spY: number } => {
  let spX = initialSpX;
  let spY = initialSpY;

  if (!startPt.isVisibleInCanvas) {
    return { spX, spY };
  }

  if (startPt.diagonalLength) {
    // adjust side for a diagonal
    const startDiagSideLen = calculateIsoscelesTriangleSide(
      startPt.angle,
      startPt.diagonalLength
    );

    spX += startDiagSideLen * cos * batAdjustStart;
    spY += startDiagSideLen * sin * batAdjustStart;
  } else if (startPt.size && startPt.size > 0.75) {
    spX += startPt.size * cos * batAdjustStart;
    spY += startPt.size * sin * batAdjustStart;
  }

  return { spX, spY };
};
